import { z } from 'zod';
import { zStringRequired } from '../../z';
import { refineSchema } from '../refine-schema';
const baseSchema = z.object({
    hhaPresent: zStringRequired(),
    clinicianName: z.string().optional(),
    ptInterviewed: zStringRequired(),
    observedCare: zStringRequired(),
    caringAttitude: zStringRequired(),
    confidentiality: zStringRequired(),
    openCommunication: zStringRequired(),
    followHHAPOC: zStringRequired(),
    safeEffectiveCare: zStringRequired(),
    infectionPrevention: zStringRequired(),
    cleanEnvironment: zStringRequired(),
    ptBenefittingHHAaid: zStringRequired(),
    aidSameFrequency: zStringRequired(),
    aidPlanUpdated: zStringRequired(),
    aidPlanUpdatedComment: z.string().optional(),
});
export const hhaSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        evaluation: refineSchema(baseSchema, (input, ctx) => {
            const payload = input;
            if (payload.hhaPresent === 'yes' && !payload.clinicianName) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Please select a clinician',
                    path: ['clinicianName'],
                });
            }
            if (payload.aidPlanUpdated === 'yes' && !payload.aidPlanUpdatedComment) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Please enter changes to the care plan',
                    path: ['aidPlanUpdatedComment'],
                });
            }
        }),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
